import { Box, Typography } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const RangeGroupingMatchHelp = () => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const items = [
    translateLabels(labels.RANGE_GROUPING_MATCH_HELP_ANY_CHARACTERS, {
      default: "* matches any number of characters.",
    }),
    translateLabels(labels.RANGE_GROUPING_MATCH_HELP_SINGLE_CHARACTER, {
      default: "? matches any single character.",
    }),
    translateLabels(labels.RANGE_GROUPING_MATCH_HELP_START_ANCHOR, {
      default:
        "^ placed at the beginning means at the start otherwise matching can be anywhere",
    }),
  ];

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant={"body2"} component={"p"}>
        {translateLabels(labels.RANGE_GROUPING_MATCH_HELP_INTRO, {
          default:
            'A matching expression can be /a standard regular expression/ or a simple wild-card expression like "fred*smith" in which:',
        })}
      </Typography>
      <Box component={"ul"} sx={{ mt: 0.5, mb: 0, pl: 3 }}>
        {items.map((item) => (
          <Typography key={item} variant={"body2"} component={"li"}>
            {item}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default RangeGroupingMatchHelp;
